/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Delete_Account_FailedInputs */

const en_mobile_delete_account_failed = /** @type {(inputs: Mobile_Delete_Account_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong deleting your account. Please try again.`)
};

const es_mobile_delete_account_failed = /** @type {(inputs: Mobile_Delete_Account_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo salió mal al eliminar tu cuenta. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Something went wrong deleting your account. Please try again." |
*
* @param {Mobile_Delete_Account_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_delete_account_failed = /** @type {((inputs?: Mobile_Delete_Account_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Delete_Account_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_delete_account_failed(inputs)
	return en_mobile_delete_account_failed(inputs)
});